import type { GameEvent } from "@/types"

export const sargonEvents: Record<string, GameEvent> = {
    "dlg-sg-pepe": {
        id: "dlg-sg-pepe",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.pepe",
                expression: "normal",
                side: "left",
                text: "map.dialog.sgPepe.d1",
            },
            {
                speaker: "map.speaker.pepe",
                expression: "normal",
                side: "left",
                text: "map.dialog.sgPepe.d2",
            },
            {
                speaker: "map.speaker.pepe",
                expression: "happy",
                side: "left",
                text: "map.dialog.sgPepe.d3",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "happy",
                side: "right",
                text: "map.dialog.sgPepe.d4",
            },
            {
                speaker: "map.speaker.pepe",
                expression: "happy",
                side: "left",
                text: "map.dialog.sgPepe.d5",
            },
            {
                speaker: "map.speaker.doctor",
                side: "right",
                text: "map.dialog.sgPepe.d6",
            },
            {
                speaker: "map.speaker.savage",
                side: "right",
                text: "map.dialog.sgPepe.d7",
            },
            {
                speaker: "map.speaker.doctor",
                side: "right",
                text: "map.dialog.sgPepe.d8",
            },
            {
                speaker: "map.speaker.pepe",
                expression: "happy",
                side: "left",
                text: "map.dialog.sgPepe.d9",
            },
        ],
        choices: [],
    },

    "dlg-sg-passenger": {
        id: "dlg-sg-passenger",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.passenger",
                expression: "calm",
                side: "left",
                text: "map.dialog.sgPassenger.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "rconfused",
                side: "right",
                text: "map.dialog.sgPassenger.d2",
            },
            {
                speaker: "map.speaker.passenger",
                expression: "calm",
                side: "left",
                text: "map.dialog.sgPassenger.d3",
            },
            {
                speaker: "map.speaker.passenger",
                expression: "calm",
                side: "left",
                text: "map.dialog.sgPassenger.d4",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "smile",
                side: "right",
                text: "map.dialog.sgPassenger.d5",
            },
            {
                speaker: "map.speaker.passenger",
                expression: "eyeclosed",
                side: "left",
                text: "map.dialog.sgPassenger.d6",
            },
            {
                speaker: "map.speaker.passenger",
                expression: "calm",
                side: "left",
                text: "map.dialog.sgPassenger.d7",
            },
            {
                speaker: "map.speaker.savage",
                side: "right",
                text: "map.dialog.sgPassenger.d8",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "smile",
                side: "right",
                text: "map.dialog.sgPassenger.d9",
            },
            {
                speaker: "map.speaker.passenger",
                expression: "eyeclosed",
                side: "left",
                text: "map.dialog.sgPassenger.d10",
            },
            {
                speaker: "map.speaker.passenger",
                expression: "calm",
                side: "left",
                text: "map.dialog.sgPassenger.d11",
            },
        ],
        choices: [],
    },

    "evt-sg-01": {
        id: "evt-sg-01",
        type: "event",
        description: "map.event.sg01.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sg01.c1",
                resultText: "map.event.sg01.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "smile",
                        text: "map.event.sg01.c1d",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sg01.c2",
                resultText: "map.event.sg01.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "smile",
                        text: "map.event.sg01.c2d",
                    },
                ],
            },
        ],
    },

    "evt-sg-02": {
        id: "evt-sg-02",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-sargon-2.png"),
        description: "map.event.sg02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sg02.c1",
                resultText: "map.event.sg02.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.pepe",
                        expression: "happy",
                        text: "map.event.sg02.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sg02.c2",
                resultText: "map.event.sg02.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.pepe",
                        expression: "happy",
                        text: "map.event.sg02.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-sg-01",
    },

    "evt-sg-03": {
        id: "evt-sg-03",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-sargon-3.png"),
        description: "map.event.sg03.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sg03.c1",
                resultText: "map.event.sg03.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.passenger",
                        expression: "calm",
                        text: "map.event.sg03.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.sg03.c2",
                resultText: "map.event.sg03.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.passenger",
                        expression: "calm",
                        text: "map.event.sg03.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-sg-02",
    },

    "evt-sg-04": {
        id: "evt-sg-04",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-sargon-4.png"),
        description: "map.event.sg04.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.sg04.c1",
                resultText: "map.event.sg04.c1r",
                nextDialogues: [
                    [
                        {
                            speaker: "map.speaker.savage",
                            text: "map.event.sg04.rd1",
                        },
                        {
                            speaker: "map.speaker.amiya",
                            expression: "confused",
                            text: "map.event.sg04.rd2",
                        },
                    ],
                ],
            },
            {
                id: "c2",
                text: "map.event.sg04.c2",
                resultText: "map.event.sg04.c2r",
                nextDialogues: [
                    [
                        {
                            speaker: "map.speaker.savage",
                            text: "map.event.sg04.rd1",
                        },
                        {
                            speaker: "map.speaker.amiya",
                            expression: "confused",
                            text: "map.event.sg04.rd2",
                        },
                    ],
                ],
            },
        ],
        unlockGalleryId: "gal-sg-03",
    },
}
